export const DEFAULT_PAGE = 1
export const DEFAULT_PAGE_SIZE = 10

/**
 * 取得預設分頁參數
 * @param {{ page?: number, size?: number }} overrides 覆寫預設值
 * @returns {{ page: number, size: number }} - 分頁參數
 */
export function getDefaultPagination(overrides = {}) {
    return { page: DEFAULT_PAGE, size: DEFAULT_PAGE_SIZE, ...overrides }
}
